import DeviceActionsModal from './device-actions-modal.connect'

export default DeviceActionsModal
